/**
 * @param {import("../../../../utils/router/Router").default} router
 */
export default function (router) {
  router.group(
    {
      path: "/alfred/bookings/:bookingId/downloads",
    },
    (router) => {
      router.group(
        {
          path: "/:downloadId",
        },
        (router) => {
          router.push({
            id: "@api/booking.download@download",
            path: "",
          });
        },
      );
    },
  );
}
